export function nativePictureInPictureDisabled(
  overlay: { readonly hasWebContents: boolean; readonly remoteControlled?: boolean } | null,
): boolean {
  return !overlay?.hasWebContents || overlay.remoteControlled === true;
}
